<script>
export default {
  name: 'JsonEditorFieldMixin',
  props: ['label', 'data', 'setData', 'vm', 'field', 'fields', 'root'],
  mounted () {
    if ('default' in this.field && this.localData === '') {
      this.localData = this.field.default
    }
  },
  data () {
    return {
      localData: this.data,
      enabled: this.field.required
    }
  },
  methods: {
    disable () {
      this.localData = 'default' in this.field ? this.field.default : ''
      this.enabled = false
    }
  },
  watch: {
    localData (newValue) {
      this.setData(newValue)
    },
    data () {
      this.localData = this.data
    }
  }
}
</script>
